<template>
  <div>
    <loc-item
      v-for="address in addresses"
      :key="`Locations-${address._id}`"
      :icon="icon"
      :address="address"
      :selected="isSelected(address)"
      :enabled="enabled"
      @click="isSingleSelected ? onSingleSelectItem(address) : onItemsClick(address, maxSelectedNum)"
    />
  </div>
</template>

<script>
import LocationItem from './locationItem'
import SelectedListMixin from '../../../mixins/list/selectedList'

export default {
  components: {
    'loc-item': LocationItem,
  },
  mixins: [SelectedListMixin],
  props: {
    addresses: {
      default: () => [],
      type: Array,
    },
    enabled: {
      default: true,
      type: Boolean,
    },
    icon: {
      default: '',
      type: String,
    },
    isSingleSelected: {
      default: false,
      type: Boolean,
    },
    maxSelectedNum: {
      default: 5,
      type: Number,
    },
    selectedAll: {
      default: false,
      type: Boolean,
    },
  },
}
</script>
